// extracted by mini-css-extract-plugin
export default {"submitFormContainer":"SubmitStartingForm_submitFormContainer__r9uy9"};